/**
 * O ponto no avatar: há coisa do Open Finance esperando por ela (19/10).
 *
 * O contador já existia, mas DENTRO do menu do avatar — só se via depois de
 * abrir o menu, ou seja, depois de já ter ido procurar. O ponto fica do lado
 * de fora e diz só "tem coisa aqui"; o número continua no item do menu.
 *
 * Um ponto e não um número pelo mesmo motivo do ponto da bolha do Finn
 * (`AdvisorChat.css`): ele espera, não cobra. Os dois falam a mesma língua e
 * moram em cantos opostos da tela, então não disputam.
 *
 * A contagem é a do servidor (`quantosEsperam`, em `/api/banco/estado`), a
 * mesma que a caixa mostra como "esperando você". Uma conta só: o ponto não
 * pode dizer "tem" quando a caixa diz "nada esperando".
 */

/** Mostra o ponto? Só com algo esperando de verdade. */
export const temPontoNoAvatar = (esperando: number | null | undefined): boolean =>
  typeof esperando === 'number' && esperando > 0;

/**
 * O nome do botão do avatar para leitor de tela. O ponto é só visual; quem
 * não vê precisa ouvir o mesmo aviso.
 */
export const rotuloDoAvatar = (esperando: number | null | undefined): string => {
  if (!temPontoNoAvatar(esperando)) return 'Menu do usuário';
  const n = esperando as number;
  return `Menu do usuário — ${n} ${n === 1 ? 'lançamento do banco esperando' : 'lançamentos do banco esperando'} você`;
};
